import { QueryClient } from "@tanstack/react-query";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { createTheme } from "@mui/material";

const typography = ["h1", "h2", "h3", "h4", "h5", "h6"].reduce((acc, each) => {
  acc[each] = {
    fontFamily: "'Poppins','Arial', sans-serif !important",
    letterSpacing: "-0.02em"
  };
  return acc;
}, {});
typography.subtitle2 = { fontSize: "0.8225rem" };

const themeConfig = {
  palette: {
    background: {
      default: "#000000"
    },
    primary: {
      main: "#000000"
    },
    secondary: {
      main: "#E30425"
    },
    success: {
      main: "#27ae60"
    },
    warning: {
      main: "#f39c12"
    },
    lightGrey: "#F4F4F4",
    lightRed: "#ffebee",
    greyText: "#757575",
    lightRedTwo: {
      main: "#FFE8E8"
    },
    disabledGray: {
      color: "rgba(0, 0, 0, 0.26)"
    },
    lightGreen: {
      main: "#42ff4838",
      mainTwo: "#C8E6C9"
    },
    primaryGreen: {
      main: "#6CCB97"
    },
    primaryRed: {
      main: "#DE6969"
    },
    primaryYellow: {
      main: "#F4A70F"
    }
  },
  typography
};

export const theme = createTheme(themeConfig);
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false },
    mutations: { retry: false }
  },
  persistQueryClient: true
});

export const persister = createSyncStoragePersister({
  storage: window.sessionStorage
});
